import { BreadcrumbsData } from './breadcrumbs.model';

export const wirelessBreadcrumbsConfig: BreadcrumbsData = {
  copy: 'subnav.wireless',
  alt: 'subnav.wireless',
  val: 'wireless',
};

export const breadCrumbsConfig = [
  {
    breadcrumbsData: [wirelessBreadcrumbsConfig],
    key: 'wireless',
    useRegEx: false,
  },
  {
    breadcrumbsData: [
      wirelessBreadcrumbsConfig,
      {
        copy: 'subnav.manage-data',
        alt: 'subnav.manage-data',
        val: '',
      },
    ],
    key: 'manage-data',
    useRegEx: false,
  },
  {
    breadcrumbsData: [
      wirelessBreadcrumbsConfig,
      {
        copy: 'subnav.talk-text-usage',
        alt: 'subnav.talk-text-usage',
        val: '',
      },
    ],
    key: 'wireless/talk-text-usage',
    useRegEx: false,
  },
  {
    breadcrumbsData: [
      {
        copy: 'subnav.financed-accessories',
        alt: 'subnav.financed-accessories',
        val: '',
      },
    ],
    key: 'financed-accessories',
    useRegEx: false,
  },
  {
    breadcrumbsData: [
      {
        copy: 'subnav.payments',
        val: '',
      },
    ],
    regexp: /^payments(.+)?/,
    useRegEx: true,
    key: 'payments',
  },
];
